<template>
    <div v-if="checkin && (checkin.banner || checkin.banner_video)" :class="['header-box', checkin.banner_video ? 'header-box--video' : '']">
        <video-box is_header  v-if="checkin.banner_video" :thumb="checkin.banner_video_thumb" :url="checkin.banner_video"></video-box>
        <img v-else-if="checkin.banner" class="header-img" :src="checkin.banner" alt="签到封面" @click.stop="previewBanner" />
        <!-- <div class="header-content">
            <span class="checkin-title">{{ checkin.title }}</span>
            <div v-if="checkin.show_item.show_total == 1">
                <div v-if="checkin.permanent" class="flex-row-between padding-tb-20">
                    <span class="title-30-white">第{{ checkin.days_current }}天</span>
                    <span class="title-30-white">共{{ checkin.join_num }}人参与</span>
                </div>
                <div v-else>
                    <div class="flex-row-between padding-tb-20">
                        <span class="title-30-white">第{{ checkin.days_current }}/{{ checkin.days_length }}天</span>
                        <span class="title-30-white">共{{ checkin.join_num }}人参与</span>
                    </div>
                    <van-progress style="border-radius: 0px" color="#fff" track-color="#777" stroke-width="6px" :show-pivot="false" :percentage="  Math.round((checkin.days_current * 100) / checkin.days_length) "></van-progress>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import VideoBox from '@/components/VideoBox.vue';
import { ImagePreview } from 'vant';
export default {
  components: { VideoBox },
    name: 'Checkintop',
    props:{
        checkin:{
            type:Object,
            default:null
        }
    },
    methods: {
        /**
         * 预览当前签到头图，行为与小程序详情页点击封面预览保持一致。
         *
         * @returns {void}
         */
        previewBanner() {
            // checkin 或 banner 为空时不触发预览，避免 ImagePreview 收到无效地址。
            if (!this.checkin || !this.checkin.banner) {
                return
            }
            ImagePreview([this.checkin.banner])
        }
    }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
    @return $px / 75 + rem;
}
.header-box {
  width: 100%;
  position: relative;
  overflow: hidden;
  max-height: rem(750);
  background-color: #fff;
}
.header-box--video {
  aspect-ratio: 750 / 420;
  max-height: none;
}
.header-img {
  display: block;
  width: 100%;
  height: auto;
}
.header-content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: rem(20) rem(30);
}
.checkin-title {
  font-size: rem(40);
  color: #fff;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.title-30-white {
  font-size: rem(30);
  color: #fff;
}
::v-deep(.header) {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckinTop.vue